/* @flow */
import React from 'react';
import View from 'components/View';
import { NavItem } from 'components/NavItem';
import AppLayoutContentView from 'app/components/AppLayoutContentView';

import './styles/IntegrationSettingsPage.scss';

type Props = {
  uuid: string,
  children: *,
};

function Navigation(props: any) {
  return (
    <React.Fragment>
      <NavItem key="content" to={`/integrations/${props.uuid}/content`}>
        Content Source
      </NavItem>
      <NavItem key="oauth" to={`/integrations/${props.uuid}/oauth`}>
        OAuth Settings
      </NavItem>
    </React.Fragment>
  );
}

class IntegrationSettingsPage extends React.Component<Props, {}> {
  render() {
    return (
      <AppLayoutContentView
        header={null}
        className="IntegrationSettingsPage"
        sidebar={<Navigation uuid={this.props.uuid} />}>
        <View full>{this.props.children}</View>
      </AppLayoutContentView>
    );
  }
}

export default IntegrationSettingsPage;
